module.exports = "<base href=\"{{appBase}}\">"